import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'
import { ValidationModal } from './ValidationModal.component'

const withUnmountHoc = withUnmountTransition(ValidationModal)
export { withUnmountHoc as ValidationModal }
